import React, { useState } from 'react';
import './ChatBot.css';
import axios from 'axios';

const ChatBot = () => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false); // State to toggle chatbot visibility

    const handleSendMessage = async () => {
        if (!newMessage.trim()) return;

        setMessages((prev) => [...prev, { role: 'user', text: newMessage }]);
        setNewMessage('');
        setLoading(true);

        try {
            const { data } = await axios.post('https://api.hgcdental.clinic/api/chat', { message: newMessage });
            setMessages((prev) => [...prev, { role: 'bot', text: data.response }]);
        } catch (error) {
            setMessages((prev) => [...prev, { role: 'bot', text: 'Error: Unable to process the message.' }]);
        } finally {
            setLoading(false);
        }
    };

    const toggleChatbot = () => setIsOpen(!isOpen);

    return (
        <div className="chatbot-container">
            {/* Toggle button with a small chat icon */}
            {/* <button className="chatbot-toggle" onClick={toggleChatbot} aria-label={isOpen ? 'Close Chat' : 'Open Chat'}>
                <img
                    src={isOpen ? '/pictures/cancel.png' : '/pictures/chatbot2.png'}
                    alt={isOpen ? 'Close Chat' : 'Open Chat'}
                    className="chatbot-icon"
                />
            </button> */}

            {isOpen && (
                <div className="chatbot-box">
                    <div className="chat-window">
                        {messages.map((msg, index) => (
                            <div
                                key={index}
                                className={`chat-message ${msg.role === 'user' ? 'user' : 'bot'}`}
                            >
                                {msg.text}
                            </div>
                        ))}
                        {loading && <div className="chat-message bot">Typing...</div>}
                    </div>
                    <div className="chat-input">
                        <input
                            type="text"
                            value={newMessage}
                            onChange={(e) => setNewMessage(e.target.value)}
                            placeholder="Type your message..."
                        />
                        <button onClick={handleSendMessage}>Send</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatBot;